import type { DeviceType } from '@previo/design-system'
import type { TPmsVersionOverride as PmsVersionOverrideData } from '~/store/user/http/types'

export class PmsVersionOverride {
  constructor(
    public readonly deviceType: DeviceType,
    public readonly canSwitch: boolean,
  ) {}

  static fromResponseData(data: PmsVersionOverrideData): PmsVersionOverride {
    return new PmsVersionOverride(data.deviceType, data.canSwitch)
  }
}
